<template>
  <div class="Warp">
    <van-grid :column-num="5" :border="false">
      <van-grid-item text="会员卡名称" />
      <van-grid-item text="会员名称" />
      <van-grid-item text="变更类型" />
      <van-grid-item text="变更数量" />
      <van-grid-item text="变更后积分" />
    </van-grid>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="uploader"
      >
        <div
          v-for="item in integralList"
          :key="item.id"
        >
          <van-grid :column-num="5" :border="false">
            <van-grid-item :text="item.card_name"> </van-grid-item>
            <van-grid-item :text="item.consumer_name"> </van-grid-item>
            <van-grid-item :text="item.type='pay'?'支付':'充值'"> </van-grid-item>
            <van-grid-item :text="String(item.change_integral)"> </van-grid-item>
            <van-grid-item :text="String(item.resule_integral)"> </van-grid-item>
          </van-grid>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      integralList: [],
      loading: false,
      refreshLoading: false,
      finished: false,
    };
  },
  mounted() {
    this.getIntegralList();
  },
  methods: {
    getIntegralList() {
      var reqData = {
        pageNum: this.page,
        pageSize: this.limit,
      };
      this.$http
        .post("/wechat/api.consumer/listIntegral", reqData)
        .then((res1) => {
          var res = res1.body;
		  if(res.total==0){
		  			  this.finished = true;
		  }else{
			  res.rows.map((v) => {
				// let data_time = v.limit_end_date.split(" ");
				// v.date = data_time[0];
				// v.time = data_time[1];
				this.integralList.push(v);
				// console.log(data_time);
				this.loading = false;
				this.refreshLoading = false;
				if (this.integralList.length >= res.total) {
				  this.finished = true;
				}
			  });
			}
        });
    },
    onRefresh() {
      this.page = 1;
      this.integralList = [];
      this.finished = false;
      this.getIntegralList();
    },
    uploader() {
      this.page++;
      this.getIntegralList();
    },
    // toDetail(item) {
    //   this.$router.push({
    //     path: "/statement_detail",
    //     query: item,
    //   });
    // },
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
</style>